import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { TkRouteContext } from "../../context/tkRouteContext";
import { httpAPI_RET012 } from "./api/request";
import { fakeTableList, schema } from "./parts";
import "./_style.scss";
import _ from "lodash";

/**
 * SCRC060130 引継ぎコード
 * @return SCRC060130 引継ぎコード
 */

const SCRC060130 = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // 認証情報
  const { state, setState } = useContext(GlobalContext);
  // 持回情報
  const { state: businessState } = useContext(BusinessContext);
  const { state: stateRouter } = useContext(TkRouteContext);
  const [stateTableList, setStateTableList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const [disButton, setDisButton] = useState(true);
  // 認証情報.ユーザタイプ
  const userType = state?.authInfo?.userType;
  // ユーザタイプが機構
  const isUserTypeKiko = userType === authorityUserType.userTypeNumber.KIKO;
  // 共済契約者番号
  const contractorNo = isUserTypeKiko
    ? businessState?.common?.contractorNo
    : state?.authInfo?.contractorNo;

  // 初期表示
  const handleInit = async () => {
    // 退職者認証コード参照API 呼び出し
    try {
      const res = await httpAPI_RET012({
        contractorNo: contractorNo,
        staffNo: location.state?.staffNo,
        applyId: location.state?.applyId,
        businessType: "JOB-33",
      });

      let resArr = stateFakeTableList.current;

      if (res.resultCd === "I0000") {
        resArr.find((item) => item.keyword === "transferCd")!.text =
          res.transferCd;
        resArr.find((item) => item.keyword === "staffNameKanji")!.text =
          res.staffNameKanji;
        resArr.find((item) => item.keyword === "workingDayNum")!.text =
          res.workingDayNum;
        const routerList = stateRouter.routerList || [];
        const herfUrl = routerList[routerList.length - 2]?.href;

        // 遷移元画面が「SCRC060031 退職者状況　管理」の場合
        if (herfUrl === "/SCRC060031") {
          setDisButton(false);
        }

        setStateTableList([...resArr]);

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    let resArr = stateFakeTableList.current;
    let contractorName = resArr.find(
      (item) => item.keyword === "contractorName"
    )!;

    contractorName.contractorNumber =
      businessState.common?.contractorNo +
      ":" +
      businessState.common?.contractorName;
    contractorName.showLine = isUserTypeKiko;

    setStateTableList([...resArr]);

    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onCheckAndSubmit = () => {
    navigate("/SCRC060118");
  };

  return (
    <Box data-testid="SCRC060130PageForTest">
      <TkFakeTable
        list={stateTableList}
        ruleSchema={schema}
        submitButtonGroup={[
          {
            submitButtonText: "次へ",
            showButton: disButton,
          },
        ]}
        buttonGroup={<TkBackButton />}
        onCheckAndSubmit={onCheckAndSubmit}
      />
    </Box>
  );
};

export default SCRC060130;
